
import { Vue, Component } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import Toast from '@/utils/toast';
import PageLoader from '@/components/shared/PageLoader.vue';
import Auth from '@/services/auth/auth';

const namespace: string = 'auth';

@Component<LoginCallback>({
	components: {
		PageLoader
	}
})
export default class LoginCallback extends Vue {
	@Action('authenticate', { namespace }) private authenticate!: () => Promise<void>;
	@Action('logout', { namespace }) private logout!: () => Promise<void>;
	@Action('clearSSO', { namespace }) private clearSSO!: () => Promise<void>;
	@Getter('isAuthenticated', { namespace }) private isAuthenticated!: boolean;
	@Getter('getRestaurants', { namespace }) private restaurants!: Tenant[];
	@Getter('getRestaurant', { namespace }) private restaurant!: Restaurant;

	private loggingLoader: boolean = false;

	private async mounted() {
		this.loggingLoader = true;
		try {
			if (!this.isAuthenticated) {
				await this.authenticate();
			}
			if (this.restaurant.dashboard && !this.restaurant.k12) {
				this.$router.replace('/dashboard').catch(() => {});
			}
			else if (this.restaurant.order_management) {
				this.$router.replace('/order-management').catch(() => {});
			}
			else {
				this.$router.replace('/menus').catch(() => {});
			}
		}
		catch (error) {
			const tempError: any = error;
			Toast.error(tempError);

			// Allow time for the user to see the error toast before being redirect back to login
			this.clearSSO();
			Auth.logout();
		}
		this.loggingLoader = false;
	}
}
